import { Component, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from './_services';
import { User } from './_models';
import { AuthService } from 'angularx-social-login';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { DateAdapter, MatDialog, MatDialogRef } from '@angular/material';
import { environment } from '../environments/environment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StaticPagesService } from './_services';
import { PrivacyComponentComponent } from './dialog/PrivacyDialog/privacy-component/privacy-component.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  currentUser: User;
  title = 'Savnet & Funnet fra DyreID';
  report: boolean = false;
  list: boolean = false;
  static: boolean = false;
  currentPath: string = '';
  @ViewChild('privacypolicy') privacypolicyRef: TemplateRef<any>;
  lostPath : string;
  foundPath : string;

  constructor(
    private authService: AuthService,
    public router: Router,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private titleService: Title, private metaService: Meta,
    private dateAdapter: DateAdapter<Date>,
    private modalService: NgbModal,
    private common: StaticPagesService,
    private privacyDialog: MatDialog
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    translate.addLangs(['en', 'no']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|no/) ? browserLang : 'no');
    this.dateAdapter.setLocale('no');
  }
  ngOnInit() {
    this.router.events.subscribe((val: any) => {
      if (val && val.url) this.currentPath = val.url;
    });
    this.titleService.setTitle(this.title);

    if (environment.production == true) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
    this.lostPath = environment.lostFoundBaseUrl +'search/found';
    this.foundPath = environment.lostFoundBaseUrl +'search/lost';
  }

  ReportAddRemove() {
    this.report = !this.report;
    this.static = false;
    this.list = false;
    event.preventDefault();
  }
  ListAddRemove() {
    this.list = !this.list;
    this.report = false;
    this.static = false;
    event.preventDefault();
  }
  StaticAddRemove() {
    this.static = !this.static;
    this.report = false;
    this.list = false;
    event.preventDefault();
  }


  public _opened: boolean = false;
  public _closeOnClickOutside = true;

  public _toggleOpened(): void {
    this._opened = !this._opened;
  }

  public _onBackdropClicked(): void {
    console.info('Backdrop clicked');
  }
  Cancel() {
    this.router.navigate(['']);
  }
  signOut(): void {
    this.authenticationService.logout();
    // this.router.navigate(['/login']);
    this.router.navigate(['']);
  }
  onActivate(event) {
    // console.log("Route activate")
    // console.log(this.router)    
    let firstElementWithError = document.querySelector('#scrollId');
    this.scrollTo(firstElementWithError);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)

  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ block: 'center' });
    }
  }


  openPrivacyPolicy() {
    this.privacyDialog.open(PrivacyComponentComponent, {
      width: "1000px",
      height: "600px",
      data: '',
      panelClass: 'privacy-dialog-class',
      autoFocus: false
    });
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', windowClass: 'my-modal-popup' }).result.then((result) => {
      //return false;
    }, (reason) => {
    });
    return false;
  }
}


